export default __webpack_public_path__ + "static/media/Deep-Daan.a5b654e5.jpg";